"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPrintableKey = exports.IsCopy = exports.IsPeriod = exports.IsMinus = exports.IsPageDown = exports.IsPageUp = exports.IsDownArrow = exports.IsRightArrow = exports.IsUpArrow = exports.IsLeftArrow = exports.IsHome = exports.IsEnd = exports.IsEscape = exports.IsKeySpace = exports.IsSpace = exports.IsEnter = exports.IsEventKey = void 0;
var keycode = require("keycode");
function IsEventKey(event, keyCode) {
    if (keycode.isEventKey(event.nativeEvent, keyCode) || event.keyCode === keyCode) {
        event.preventDefault();
        return true;
    }
    else {
        return false;
    }
}
exports.IsEventKey = IsEventKey;
function IsEnter(event) { return IsEventKey(event, keycode.codes.enter); }
exports.IsEnter = IsEnter;
function IsSpace(event) { return IsEventKey(event, keycode.codes.space); }
exports.IsSpace = IsSpace;
function IsKeySpace(event) { return event.keyCode === keycode.codes.space; }
exports.IsKeySpace = IsKeySpace;
function IsEscape(event) { return IsEventKey(event, keycode.codes.esc); }
exports.IsEscape = IsEscape;
function IsEnd(event) { return IsEventKey(event, keycode.codes.end); }
exports.IsEnd = IsEnd;
function IsHome(event) { return IsEventKey(event, keycode.codes.home); }
exports.IsHome = IsHome;
function IsLeftArrow(event) { return IsEventKey(event, keycode.codes.left); }
exports.IsLeftArrow = IsLeftArrow;
function IsUpArrow(event) { return IsEventKey(event, keycode.codes.up); }
exports.IsUpArrow = IsUpArrow;
function IsRightArrow(event) { return IsEventKey(event, keycode.codes.right); }
exports.IsRightArrow = IsRightArrow;
function IsDownArrow(event) { return IsEventKey(event, keycode.codes.down); }
exports.IsDownArrow = IsDownArrow;
function IsPageUp(event) { return IsEventKey(event, keycode.codes["page up"]); }
exports.IsPageUp = IsPageUp;
function IsPageDown(event) { return IsEventKey(event, keycode.codes["page down"]); }
exports.IsPageDown = IsPageDown;
function IsMinus(event) { return IsEventKey(event, keycode.codes["-"]) || IsEventKey(event, keycode.codes["numpad -"]); }
exports.IsMinus = IsMinus;
function IsPeriod(event) { return IsEventKey(event, keycode.codes["."]) || IsEventKey(event, keycode.codes["numpad ."]); }
exports.IsPeriod = IsPeriod;
function IsCopy(event) { return (event.ctrlKey || event.metaKey) && event.keyCode === keycode.codes.c; }
exports.IsCopy = IsCopy;
function IsPrintableKey(keyCode) {
    return ((keyCode > 47 && keyCode < 58) || // number keys
        (keyCode === 32 || keyCode === 13) || // spacebar & return key(s) (if you want to allow carriage returns)
        (keyCode > 64 && keyCode < 91) || // letter keys
        (keyCode > 95 && keyCode < 112) || // numpad keys
        (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
        (keyCode > 218 && keyCode < 223)); // [\]' (in order)
}
exports.IsPrintableKey = IsPrintableKey;
